import type { QueryRequest } from './api';

function encodeSelected(selected: Record<string, number[]>): string {
    return Object.entries(selected)
        .filter(([, v]) => v && v.length > 0)
        .map(([k, v]) => `${encodeURIComponent(k)}=${v.join(',')}`)
        .join(';');
}

function decodeSelected(s: string | null): Record<string, number[]> {
    const out: Record<string, number[]> = {};
    if (!s) return out;
    for (const part of s.split(';')) {
        const eq = part.indexOf('=');
        if (eq < 0) continue;
        const key = decodeURIComponent(part.slice(0, eq));
        const ids = part.slice(eq + 1).split(',').map(Number).filter(Number.isFinite);
        if (ids.length > 0) out[key] = ids;
    }
    return out;
}

export function readFromUrl(): Partial<QueryRequest> {
    const p = new URLSearchParams(window.location.search);
    const req: Partial<QueryRequest> = {};
    if (p.has('q')) req.text = p.get('q')!;
    if (p.has('f')) req.selected = decodeSelected(p.get('f'));
    if (p.has('pf')) req.priceFrom = Number(p.get('pf'));
    if (p.has('pt')) req.priceTo = Number(p.get('pt'));
    if (p.has('s')) req.sort = p.get('s')!;
    if (p.has('p')) req.page = Number(p.get('p')) || 1;
    return req;
}

export function writeToUrl(state: QueryRequest, replace = true): void {
    const p = new URLSearchParams();
    if (state.text) p.set('q', state.text);
    if (state.selected && Object.keys(state.selected).length > 0)
        p.set('f', encodeSelected(state.selected));
    if (state.priceFrom != null) p.set('pf', String(state.priceFrom));
    if (state.priceTo != null) p.set('pt', String(state.priceTo));
    if (state.sort && state.sort !== 'Relevance') p.set('s', state.sort);
    if (state.page && state.page > 1) p.set('p', String(state.page));

    const url = `${window.location.pathname}${p.toString() ? '?' + p.toString() : ''}`;
    if (replace) history.replaceState(null, '', url);
    else history.pushState(null, '', url);
}
